import * as i0 from "@angular/core";
export class CodeVerificationStore {
}
CodeVerificationStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CodeVerificationStore_Factory() { return new CodeVerificationStore(); }, token: CodeVerificationStore, providedIn: "root" });
export var CodeVerificationStoreKeys;
(function (CodeVerificationStoreKeys) {
})(CodeVerificationStoreKeys || (CodeVerificationStoreKeys = {}));
